import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoService } from '@ngneat/transloco';
import { PreflashMonitoringContent } from '@shared/models/PreflashMonitoring';

@Component({
  standalone: false,
  selector: 'app-fcsc-admin-preflash-monitoring',
  templateUrl: './fcsc-admin-preflash-monitoring.html',
  styleUrls: ['./fcsc-admin-preflash-monitoring.scss'],
})
export class FcscAdminPreflashMonitoringComponent implements OnInit {

  form!: UntypedFormGroup;
  preflashData: PreflashMonitoringContent[] = [];
  filteredPreflashData: PreflashMonitoringContent[] = [];
  selectedCalculationResult?: PreflashMonitoringContent;
  objectKeys = Object.keys;
  @ViewChild('calculationDetailsModal') calculationDetailsModal!: TemplateRef<any>;

  constructor (
      private readonly translocoService: TranslocoService,
      private readonly formBuilder: UntypedFormBuilder,
      private readonly modalService: NgbModal,
    ) {
  }

  ngOnInit(): void {
    // TODO: Implement the logic to fetch and populate preflashData from the backend service.
    // TODO: check timezone and adjust logic accordingly
    this.preflashData = [{
      series: 'C169',
      fin: 'WDD1690321J312294',
      appointment_date: '06.06.23 19:57:26',
      calculation_time: '06.06.23 19:57:26',
      status: 'ready',
      system: 'xentry',
      sdp: '230606_162714_C117_man',
      vp5_version: '7.2.0',
      as_tact: 'T26.05',
      calulation_response: {
        result: {
          'BC_F206': {
            'flashRequirement': true,
            'seamless': true
          },
          'CPC3': {
            'flashRequirement': true,
            'seamless': false
          },
          'DISPC223': {
            'flashRequirement': true,
            'seamless': false
          },
          'EBB223': {
            'flashRequirement': false,
            'seamless': true
          },
          'EBB22': {
            'flashRequirement': false,
            'seamless': true
          }
        },
        history: [{
          creation_time: '06.06.23 19:57:26',
          status: 'ready'
        },{
          creation_time: '06.06.23 19:57:26',
          status: 'error'
        }]
      }
    },
  {
      series: 'C211',
      fin: 'WDB2116081B445482',
      appointment_date: '06.06.23 19:57:26',
      calculation_time: '06.06.23 19:57:26',
      status: 'error',
      system: 'System A',
      sdp: '230606_162714_C117_man',
      vp5_version: '7.1.0',
      as_tact: 'T26.05',
      error_message: 'Calculation failed due to missing data.',
      calulation_response: {
        history: [{
          creation_time: '06.06.23 19:57:26',
          status: 'ready'
        },{
          creation_time: '06.06.23 19:57:26',
          status: 'error'
        }]
      }
    },
  {
      series: 'C223',
      fin: 'W1K2230301A012208',
      appointment_date: '06.06.23 19:57:26',
      calculation_time: '06.06.23 19:57:26',
      status: 'recalculation',
      system: 'System B',
      sdp: '230606_162714_C117_man',
      vp5_version: '7.2.0',
      as_tact: 'T26.05',
      calulation_response: {
        history: [{
          creation_time: '06.06.23 19:57:26',
          status: 'ready'
        },{
          creation_time: '06.06.23 19:57:26',
          status: 'error'
        }]
      }
    },
  {
      series: 'C223',
      fin: 'W1K2230301A012208',
      appointment_date: '06.06.23 19:57:26',
      calculation_time: '',
      status: 'pending',
      system: 'Xentry',
      sdp: '230606_162714_C117_man',
      vp5_version: '7.2.0',
      as_tact: 'T26.05',
    },
  {
      series: 'C169',
      fin: 'WDD1690321J312294',
      appointment_date: '06.06.23 19:57:26',
      calculation_time: '',
      status: 'queued',
      system: 'System B',
      sdp: '230606_162714_C117_man',
      vp5_version: '7.1.0',
      as_tact: 'T26.05',
    }];
    this.createForm();
    this.filteredPreflashData = [...this.preflashData];
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      seriesFilter: '',
      finFilter: '',
      appointmentDateFilter: '',
      calculationTimeFilter: '',
      statusFilter: '',
      systemFilter: '',
      sdpFilter: '',
      vp5VersionFilter: '',
      asTactFilter: '',
    });
  }

  private matches(value: string | undefined, filter: string): boolean {
    if (!filter) {
      return true;
    }
    return (value || '').toLowerCase().includes(filter.toLowerCase());
  }

  applyFilter(): void {
    const filterValues = this.form.getRawValue();
    this.filteredPreflashData = this.preflashData.filter((row) =>
      this.matches(row.series, filterValues.seriesFilter) &&
      this.matches(row.fin, filterValues.finFilter) &&
      this.matches(row.appointment_date, filterValues.appointmentDateFilter) &&
      this.matches(row.calculation_time, filterValues.calculationTimeFilter) &&
      this.matches(row.status, filterValues.statusFilter) &&
      this.matches(row.system, filterValues.systemFilter) &&
      this.matches(row.sdp, filterValues.sdpFilter) &&
      this.matches(row.vp5_version, filterValues.vp5VersionFilter) &&
      this.matches(row.as_tact, filterValues.asTactFilter)
    );
  }

  resetFilter(): void {
    this.form.reset();
    this.filteredPreflashData = [...this.preflashData];
  }

  openCalculationDetails(calculationResult: PreflashMonitoringContent): void {
    this.selectedCalculationResult = calculationResult;
    this.modalService.open(this.calculationDetailsModal, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
    });
  }

}
